import React from "react"
import Head from "../components/head"
import Layout from "../components/layout"
import "../styles/index.scss"

export default function Contact() {
  return (
    <Layout>
      <Head title="Contact" />
      <h1>Contact Page</h1>

      <h2>Contact content will render here. </h2>
    </Layout>
  )
}
